import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import communityGardenHarvestListAction from './communityGardenHarvestList.action.json' with { type: 'json' }
import { communityGardenHarvestObject } from '../../communityGardenHarvestObject'

export const communityGardenHarvestExpression = expression(communityGardenHarvestObject.shape)

const communityGardenHarvestListDefinition = defineAction({
  ...communityGardenHarvestListAction,

  input: z.object({
    filter: communityGardenHarvestExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      type: 'Tipo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({ items: z.array(communityGardenHarvestObject), count: z.number() }),
})

export default communityGardenHarvestListDefinition
